import React from 'react'

import { UserBadge } from '@components/UserBadge'
import { useModal } from '@hooks/app/modal.hook'
import { useMe } from '@hooks/user/me.hook'

import { Container, HeaderContainer, HeaderContent, MainContainer } from './mobile.main.styled'

interface Props {
  HeaderComponent?: React.ReactNode
  MainComponent?: React.ReactNode
}

export const MobileMainLayout = (props: Props): JSX.Element => {
  const { HeaderComponent, MainComponent } = props

  const { getMe } = useMe()
  const { displayModal } = useModal()

  return (
    <Container>
      {HeaderComponent && (
        <HeaderContainer>
          <HeaderContent>
            {HeaderComponent}
            <UserBadge user={getMe()} size="large" onClick={() => displayModal('settings')} />
          </HeaderContent>
        </HeaderContainer>
      )}
      <MainContainer>{MainComponent}</MainContainer>
    </Container>
  )
}
